import { Controller } from "@hotwired/stimulus"

// Copies the source text to the clipboard and briefly confirms.
export default class extends Controller {
  static targets = ["source", "button"]

  copy() {
    const text = this.sourceTarget.textContent.trim()
    navigator.clipboard.writeText(text).then(() => this.flash())
  }

  flash() {
    if (!this.hasButtonTarget) return
    const original = this.buttonTarget.innerHTML
    this.buttonTarget.textContent = "Copied!"
    setTimeout(() => { this.buttonTarget.innerHTML = original }, 1500)
  }
}
